module.exports = __webpack_public_path__ + "static/img/translation4.4ed8247.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/result/4/translation4.png
// module id = HzKc
// module chunks = 0